import React from 'react';

import { Button } from '@mui/material';

function AnimatedImage({ src, boardHeight, scale=1, sx, alt='image', onClick, tick=0 }) {

    const [imageDimensions, setImageDimensions] = React.useState({ width: null, numSequences: null });

    React.useEffect(() => {
        if (!src) {
            setImageDimensions({ width: null, numSequences: null });
            return;
        }
        const img = new window.Image();
        img.onload = () => {
            const seqTmp = Math.floor(img.height / boardHeight);
            setImageDimensions({ width: img.width, numSequences: seqTmp });
            //console.log(`Image dimensions: ${img.width}x${img.height} with ${seqTmp} sequences`);
        };
        img.src = src;
    }, [src, boardHeight]);

    const frame = imageDimensions.numSequences ? tick % imageDimensions.numSequences : 0;

    return (
        <Button
            sx={{
                ...sx,
                backgroundImage: `url(${src})`,
                backgroundPosition: `0 -${frame * boardHeight * scale}px`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: `${imageDimensions.width * scale}px ${boardHeight * imageDimensions.numSequences * scale}px`,
            }}
            onClick={onClick}
        />
    );
}

export default AnimatedImage;